var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM13.4732 11.9918L16.7992 15.2754L15.3204 16.7542L12.0064 13.473L8.71162 16.8002L7.24522 15.3338L10.5276 12.0086L7.19922 8.71259L8.66562 7.2462L11.9896 10.5274L15.2744 7.2002L16.7532 8.679L13.4732 11.9918Z","fill":"currentColor"}));
}

Close.defaultProps = {"viewBox":"0 0 24 24","fill":"none","style":{"color":"#39424A"}};

module.exports = Close;

Close.default = Close;
